import { render, staticRenderFns } from "./ipsyo.vue?vue&type=template&id=1cef676f&scoped=true&"
import script from "./ipsyo.vue?vue&type=script&lang=js&"
export * from "./ipsyo.vue?vue&type=script&lang=js&"
import style0 from "./ipsyo.vue?vue&type=style&index=0&id=1cef676f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cef676f",
  null
  
)

export default component.exports